import { Modal, ModalContent } from '@braskai/ui-kit';

import type { ReactNode } from 'react';

import { HubSpotMeetings } from '@/shared/thirdParty/hubSpot';
import { ModalHeaderDefault } from '@/shared/ui/modal';

const TITLE = 'Book your 30-minute Rask demo';
const SUBTITLE = (
  <>
    You&apos;ll get a personalized walkthrough of the product, hear proven customer success
    <br />
    stories, and learn about pricing for your use case.
  </>
);

const PAPER_SX = {
  centered: { height: 'auto', maxHeight: 'calc(100dvh - 80px)', mx: '12px', my: '40px' },
  default: { height: 'calc(100dvh - 24px)', m: '12px', maxHeight: 'calc(100dvh - 24px)' },
} as const;

type DemoBookingCalendarModalProps = {
  title?: ReactNode;
  email?: string;
  layout?: keyof typeof PAPER_SX;
  meetingUrl: string;
  secondaryAction?: ReactNode;
  subtitle?: ReactNode;
  onBooked: (startsAt?: Date) => void;
  onClose: () => void;
  onLoadError?: () => void;
};

export const DemoBookingCalendarModal = ({
  title = TITLE,
  email,
  layout = 'default',
  meetingUrl,
  secondaryAction,
  subtitle = SUBTITLE,
  onBooked,
  onClose,
  onLoadError,
}: DemoBookingCalendarModalProps) => {
  const isCentered = layout === 'centered';

  return (
    <Modal
      PaperProps={{ sx: PAPER_SX[layout] }}
      size="lg"
      // Must clear the raw MUI modals it can be opened from (trial paywall sits on zIndex.modal).
      sx={{ zIndex: (theme) => theme.zIndex.modal + 1 }}
      open
      onClose={onClose}
    >
      <ModalHeaderDefault
        title={title}
        align={isCentered ? 'center' : 'left'}
        gap={isCentered ? 8 : undefined}
        subtitle={subtitle}
        onClose={onClose}
      />

      <ModalContent
        sx={{
          '& .meetings-iframe-container': { width: '100%' },
          '& .meetings-iframe-container iframe': { display: 'block', width: '100% !important' },
          flex: 1,
          minHeight: 0,
          overflowY: 'auto',
          ...(isCentered && { '&&': { pt: 0 } }),
        }}
      >
        <HubSpotMeetings email={email} meetingUrl={meetingUrl} onBooked={onBooked} onLoadError={onLoadError} />

        {secondaryAction}
      </ModalContent>
    </Modal>
  );
};
